import { DepartmentData } from '@shared/interfaces/DepartmentData';

export const projectIdsToName = (ids: string[], data: DepartmentData[]): string[] =>
  ids.reduce((acc, id) => {
    data.map((project) => {
      if (project.id === id) acc.push(project.name);
    });
    return acc;
  }, [] as string[]);
